import { useEffect } from "react";

export default function SliderNew() {
    useEffect(()=>{
        const slides = document.getElementsByClassName('slider');
        console.log(slides.length);
        let i =0;
        setInterval(()=>{
            if(i<3){
                for (const iterator of slides) {
                    iterator.classList.remove('slideropacityshow');
                    iterator.classList.add('slideropacityhidden');
                }
                i++;
                slides[i].classList.add('slideropacityshow');
            }else{
                i = 0;
                for (const iterator of slides) {
                    iterator.classList.remove('slideropacityshow');
                    iterator.classList.add('slideropacityhidden');
                }
                slides[i].classList.add('slideropacityshow');
            }
        },3000)
    },[])
    
    return (
        <>
            <div className='customSlider'>
                <div className='slider slideropacityshow'>
                    <img src="./images/sl1cr1.jpg" alt="asgfsdg" />
                </div>
                <div className='slider slideropacityhidden'>
                    <img src="./images/sl2cr2.jpg" alt="asgfsdg" />
                </div>

                <div className='slider slideropacityhidden'>
                    <img src="./images/sl3cr3.jpg" alt="asgfsdg" />
                </div>

                <div className='slider slideropacityhidden'>
                    <img src="./images/sl4cr4.jpg" alt="asgfsdg" />
                </div>
            </div>

        </>
    )
}